import { useRouter } from 'next/router';
import React from 'react';
import { connect } from 'react-redux';

import ListPageStates from '@/src/shared/components/ListPage/ListPageStates';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import { COMPLIANCE_ACCESS } from '@/src/shared/constants';
import useListSearch from '@/src/shared/hooks/useListSearch';
import states from '@/utils/states';

const searchOptions = {
  pubCode: 831,
  yearsBack: 5,
};

const MarketConductBulletin = props => {
  const router = useRouter();
  const { statecode } = props;
  const _statecode = statecode || router.query.slug || 0;
  const [loading, results] = useListSearch(searchOptions, _statecode);

  return (
    <ListPageStates
      title="Market Conduct Bulletin"
      heroContent={<p>Documents from the last 5 years</p>}
      results={results}
      truncateResultSummary
      searchOptions={searchOptions}
      statecode={_statecode}
      loading={loading}
      titlePrefix=""
      routeBase="/compliance/market-conduct/bulletin"
    />
  );
};

export async function getStaticPaths() {
  return {
    paths: states.map(s => ({ params: { slug: s.StateCode } })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  return {
    props: {
      statecode: params.slug || 0,
    },
  };
}

export default connect(mapStateToProps)(
  withMembershipAccessWrap(MarketConductBulletin, COMPLIANCE_ACCESS.MARKET_CONDUCT)
);
